import React from 'react';

export const BulkLabelNotification = ({ name, resourcesCount }) => ({
  added: (
    <React.Fragment>
      {`You’ve added the “${name}” label to ${resourcesCount} ${
        resourcesCount > 1 ? 'resources' : 'resource'
      }.`}
      <br />
    </React.Fragment>
  ),
});
